module.exports = __webpack_public_path__ + "img/courseCharts.8a12b392.svg";